var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.968 2.03198C13.0363 1.1003 11.5257 1.10035 10.5941 2.03208L2.62739 9.99971C2.35651 10.2706 2.16611 10.6114 2.07737 10.9841L1.34698 14.0517C1.30676 14.2206 1.35706 14.3983 1.47983 14.5211C1.60261 14.6439 1.78029 14.6941 1.94919 14.6539L5.01669 13.9236C5.3895 13.8348 5.73035 13.6443 6.00131 13.3733L13.9681 5.40566C14.8996 4.474 14.8996 2.96359 13.968 2.03198ZM11.3012 2.73915C11.8423 2.19798 12.7197 2.19795 13.2608 2.73909C13.8019 3.28018 13.802 4.15747 13.2609 4.69859L12.6667 5.29289L10.7071 3.33333L11.3012 2.73915ZM10 4.04048L11.9596 6.00004L5.29416 12.6663C5.15406 12.8064 4.97783 12.9049 4.78507 12.9508L2.50798 13.4929L3.05018 11.2157C3.09606 11.023 3.19449 10.8468 3.33454 10.7068L10 4.04048Z",
    fill: "#49484D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.e096b4d0e4a9e2fc27b993ffbb7bd4b4.svg";
export { ForwardRef as ReactComponent };